import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter, StringCompare } from '@stamhoofd/utility';
import { v4 as uuidv4 } from "uuid";
export class EmergencyContact extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.phone = null;
        this.title = "Oma"; // TODO
    }
    /**
     * Call this to clean up capitals in all the available data
     */
    cleanData() {
        if (StringCompare.isFullCaps(this.name)) {
            this.name = Formatter.capitalizeWords(this.name.toLowerCase());
        }
        if (StringCompare.isFullCaps(this.title)) {
            this.title = this.title.toLowerCase();
        }
        this.name = Formatter.capitalizeFirstLetter(this.name.trim());
        this.title = this.title.trim();
        this.title = Formatter.capitalizeFirstLetter(this.title);
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], EmergencyContact.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmergencyContact.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmergencyContact.prototype, "phone", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmergencyContact.prototype, "title", void 0);
//# sourceMappingURL=EmergencyContact.js.map